import { Navigator, Slot } from 'expo-router';

export {
  // Catch any errors thrown by the Layout component, and display an error.
  ErrorBoundary
} from 'expo-router';

const BottomTabsLayoutWeb = () => (
  <Navigator>
    <Slot />
  </Navigator>
);

export default BottomTabsLayoutWeb;
